import React from 'react';
import PropTypes from 'prop-types';
import { SIDEBAR_VIEWS } from '../../../../../lib/constants';
import Button from '../../../../Button';
import styles from '../SavedContent.module.scss';
import WaypointIcon from '../../../../../assets/svg/WaypointIcon';


function NoUserData(props) {
  const goToDataManager = (e) => {
    e.preventDefault();
    props.gotoSidebar(SIDEBAR_VIEWS.DataManager);
  };

  return (
    <div className={styles.noUserData}>
      <WaypointIcon
        width={60}
      />
      <p className={styles.noUserContent}>
        Use the map tools to start creating content or import content from other
        sources.
      </p>
      <Button theme={Button.THEME.default} onClick={goToDataManager}>
        Import KML or GPX file
      </Button>
    </div>
  );
}

NoUserData.propTypes = {
  gotoSidebar: PropTypes.func,
};

export default NoUserData